import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { TfiCommentAlt } from "react-icons/tfi";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { MdDownload } from "react-icons/md";

export default function AttendedStudent({ OpenNext, setOpenNext }) {
  const { attendedCount } = useSelector((s) => s.AttendedStuentCountReducer);
  const [contactComment, setContactComment] = useState([]);
  const handleCancel1 = () => {
    setOpenNext(false);
  };
  //   console.log(contactComment);

  let LeadJson = [
    "Apply Immediately",
    "Prospective",
    "Eligible",
    "Not Eligible",
    "Opened By Mistake",
  ];

  const ExportExcel = () => {
    let formattedData = [];

    contactComment.forEach((student) => {
      student.CommentC.forEach((comment) => {
        formattedData.push({
          StudentId: student?.Contact_Id,
          Name: student.ContactName,
          FullName: student?.Full_Name,
          Comment: comment,
          ContactStatus: student?.Contact_Type,
          Date: moment(student.Created_Date).format("MMMM Do YYYY"),
        });
      });
    });

    // Create a worksheet
    const worksheet = XLSX.utils.json_to_sheet(formattedData);

    // Create a workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Students");

    // Write the workbook and trigger the download
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(data, "students.xlsx");
  };

  useEffect(() => {
    let atnd = [];

    for (let i = 0; i < attendedCount?.length; i++) {
      let Std = { ...attendedCount[i], CommentC: [] };
      let findC = atnd.find(
        (ev) => ev?.Contact_Id == attendedCount[i]?.Contact_Id
      );

      if (findC == undefined || findC == "") {
        for (let j = i; j < attendedCount?.length; j++) {
          if (attendedCount[j]?.Contact_Id == Std?.Contact_Id) {
            Std?.CommentC.push(attendedCount[j]?.Comment);
          }
        }
        atnd.push({ ...Std });
      }
    }
    setContactComment([...atnd]);
  }, [attendedCount]);

  return (
    <div
      id="CreatContact"
      className={OpenNext ? "overlay-note w-100" : "overlay-note"}
      style={{ top: "", zIndex: "100" }}
    >
      <div className="overlay-note-content mblVwe">
        <div className="note-title">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h4 className="text-left text-white pl-3">Comments </h4>
            <button
              style={{ marginRight: "35px" }}
              className="cst_btn2"
              onClick={() => ExportExcel()}
            >
              <span>
                <MdDownload />
              </span>{" "}
              Download Sheet
            </button>{" "}
          </div>

          <div className="closebtn">
            {/* <a id="hide-note-max" className="text-right text-white">
              <i className="fas fa-minus"></i>
            </a> */}
            <a
              style={{ cursor: "pointer" }}
              className="text-right text-white"
              onClick={() => handleCancel1(false)}
            >
              <i className="fas fa-times"></i>
            </a>
          </div>
        </div>
        <div
          style={{ padding: "20px", height: "60vh", overflowY: "scroll" }}
          className="Send_Email_Form"
          id="noteBody"
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <div style={{ width: "100%" }} className="d-flex flex-column">
              <div className="  mt-1">
                {contactComment?.map((ev) => (
                  <>
                    <div className="d-flex flex-row align-items-center">
                      <img
                        className="rounded-circle"
                        src="/assets/img/Deafult-user.png"
                        alt=""
                        width="40"
                      />
                      <h5
                        style={{
                          marginLeft: "20px",
                          fontWeight: "bold",
                          color: "#f26524",
                        }}
                      >
                        {ev?.ContactName || ev?.Full_Name} - {ev?.Contact_Id}
                      </h5>
                    </div>
                    {ev.CommentC?.map((el) => (
                      <div className="card-body">
                        <div className="comment-content bg-white p-2">
                          <div
                            className="d-flex flex-row align-items-center  user-info"
                            style={{ color: "#020635" }}
                          >
                            {/* <img
                              className="rounded-circle"
                              src="assets/img/Deafult-user.png"
                              alt=""
                              width="40"
                            /> */}
                            <TfiCommentAlt />

                            <div className="d-flex flex-column justify-content-start ml-2">
                              {/* <span className="d-block font-weight-bold name">
                                {record.Guest_Name || record?.First_Name}
                              </span> */}
                              <span
                                style={{ color: "#020635" }}
                                className="date text-black-80"
                              >
                                {/* {record.Institute} -{" "} */}
                                {moment(ev.Created_Date).format("MMMM Do YYYY")}
                              </span>
                            </div>
                          </div>
                          <div className="mt-2 ml-3">
                            <p
                              style={{ color: "black" }}
                              className="comment-text"
                            >
                              {el}
                            </p>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                              }}
                            >
                              {ev?.Contact_Type ? (
                                <p className="contact_t">{ev?.Contact_Type}</p>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                ))}
              </div>
              <div
                style={{ display: "flex", gap: "10px", padding: "10px 0" }}
              ></div>
            </div>

            
          </div>
        </div>
        <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
                padding:"20px 0"
              }}
            >
              {/* <button
                className="cst_btn"
                onClick={(e) => handleCommentSubmit(e)}
              >
                Add
              </button>{" "} */}
              <button className="cst_btn" onClick={() => handleCancel1()}>
                Cancel
              </button>{" "}
            </div>
      </div>
      
    </div>
  );
}
